import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../assets/logo.png';
import '../styles/style.css';
// import supabase from "../services/supabaseClient";
import { supabase } from '../services/supabaseClient';

const SERVER_URL = `http${process.env.REACT_APP_API_URL}`;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Supabase Auth - Sign in with email/password
      const { data, error } = await supabase.auth.signInWithPassword({
        email: username,
        password: password,
      });

      if (error) throw error;

      // Confirm if Superbase session is valid
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (session == null) {
        throw new Error("No active session found");
      }

      console.log("DEBUG: Login successful, session:", session);

      const token = session.access_token;
      console.log("DEBUG: token=" + token)

      // Run into this issue where the token does not available in the first attempt
      let userRes;
      const retry = 3;
      for (let i = 0; i < retry; i++) {
        try {
          userRes = await fetch(`${SERVER_URL}/me`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (userRes.ok) break;
          console.warn(`Attempt ${i + 1} failed with status: ${userRes.status}`);
        } catch (err) {
          console.error(`Attempt ${i + 1} failed with network error:`, err);
        }
        if (i < 2) await new Promise((resolve) => setTimeout(resolve, 1000));
      }

      if (userRes && userRes.ok) {
        let userData = await userRes.json();
        if (typeof userData === 'string') {
          try {
            userData = JSON.parse(userData);
          } catch (e) {
            console.error("Error parsing userData string:", e);
          }
        }
        localStorage.setItem("user", JSON.stringify(userData));

        console.log("Login successful");
        if (userData.role === 'ward') {
          window.location.href = "/preferences";
        } else {
          window.location.href = "/";
        }
      } else {
        throw new Error("Failed to retrieve user info");
      }
    } catch (error) {
      alert("Invalid credentials or server error");
      console.error(error);
    }
  };

  return (
    <div className="login-container">
      {/* Logo Section */}
      <div className="logo-section">
        <img src={logoImage} alt="Guardian Sphere Logo" className="login-logo-image" />
        <div className="login-logo-text">GUARDIAN SPHERE</div>
      </div>

      {/* Form Container */}
      <div className="login-form-wrapper">
        <form onSubmit={handleLogin}>
          <h2>Guardian Portal Login</h2>

          <input
            type="text"
            placeholder="Email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit">Log In</button>

          <div className="form-footer">
            Don't have an account? <a href="/register">Register now</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;